import { AnyExtension } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'

import { SHARED_RICHTEXT_EXTENSIONS } from '~shared/richtext/richtext.extensions'

import { CustomShortcutsExtension } from '@/features/rundown/cell/cell-types/richtext/tiptap.shortcuts'

import { FileNode } from './nodes/file/FileNode'
import { ImageNode } from './nodes/image/ImageNode'
import { MentionNode } from './nodes/mentions/MentionNode'
import { TaskItemNode } from './nodes/taskitem/TaskItemNode'
import { VariableNode } from './nodes/variables/VariableNode'

/**
 * Cached collection of Tiptap extensions for RichtextColumnCell editor.
 *
 * Should extend {@link SHARED_RICHTEXT_EXTENSIONS}
 */
export const CLIENT_RICHTEXT_EXTENSIONS = [
  // Shared collection
  ...SHARED_RICHTEXT_EXTENSIONS,
  // Client-only custom nodes
  ImageNode,
  FileNode,
  MentionNode,
  VariableNode,
  TaskItemNode,
  // Client-only extensions
  CustomShortcutsExtension,
] as const satisfies AnyExtension[]

/**
 * Cached collection of Tiptap extensions Mentions descroption editor.
 *
 * Does not extend any shared collection.
 */
export const CLIENT_MENTIONS_EXTENSIONS = [
  StarterKit.configure({
    heading: false,
    codeBlock: false,
    blockquote: false,
    horizontalRule: false,
  }),
  // Client-only custom nodes
  ImageNode, // (Only ImageNode is allowed)
]
